var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00004 2.73203L3.33337 3.66536L4.26671 1.9987L3.33337 0.332031L5.00004 1.26536L6.66671 0.332031L5.73337 1.9987L6.66671 3.66536L5.00004 2.73203ZM13 9.26536L14.6667 8.33203L13.7334 9.9987L14.6667 11.6654L13 10.732L11.3334 11.6654L12.2667 9.9987L11.3334 8.33203L13 9.26536ZM14.6667 0.332031L13.7334 1.9987L14.6667 3.66536L13 2.73203L11.3334 3.66536L12.2667 1.9987L11.3334 0.332031L13 1.26536L14.6667 0.332031ZM8.89337 7.5187L10.52 5.89203L9.10671 4.4787L7.48004 6.10536L8.89337 7.5187ZM9.58004 3.8587L11.14 5.4187C11.4 5.66536 11.4 6.0987 11.14 6.3587L3.36004 14.1387C3.10004 14.3987 2.66671 14.3987 2.42004 14.1387L0.860039 12.5787C0.600039 12.332 0.600039 11.8987 0.860039 11.6387L8.64004 3.8587C8.90004 3.5987 9.33337 3.5987 9.58004 3.8587Z",
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagic);
export default __webpack_public_path__ + "static/media/magic.4007bb6a70eda5768c974c9a5e5f71a5.svg";
export { ForwardRef as ReactComponent };